import { __decorate } from "tslib";
// Core
import { Component, Prop, Mixins } from 'vue-property-decorator';
// Extends
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
// Children
import AccountDetails from '@/views/v3/inbox_manager/AccountDetails.vue';
import AgentBreakdown from '@/components/v3/inbox_manager/AgentBreakdown.vue';
// Models / Helpers
import { EventBus, EventBusTriggers } from '@/helpers/EventBus';
// Queries / Mutations
let InboxWidget = class InboxWidget extends Mixins(ViewportSizeMixin) {
    constructor() {
        super(...arguments);
        this.emptyStateIcon = require('@/assets/icons/account-detail-icon.svg');
        this.tabNames = ['Customer Profile', 'Response Breakdown'];
        this.tabComponents = ['account-details', 'agent-breakdown'];
        this.currentTab = null;
    }
    setTab(tab) {
        this.currentTab = tab;
    }
    mounted() {
        EventBus.$on(EventBusTriggers.setInboxWidgetTab, this.setTab);
    }
    beforeDestroy() {
        EventBus.$off(EventBusTriggers.setInboxWidgetTab, this.setTab);
    }
};
__decorate([
    Prop({ type: Boolean, default: false })
], InboxWidget.prototype, "isMobile", void 0);
InboxWidget = __decorate([
    Component({
        components: {
            AccountDetails,
            AgentBreakdown,
        },
    })
], InboxWidget);
export default InboxWidget;
